import React, { FC, useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { PredefinedMilisecondsTypeEnum } from '../../lib/enums';
import lang from '../../lib/language';
import { RootState } from '../../lib/store';
import { getDefaultSelectableTradingPLanFromState } from '../../lib/store/crm/helpers';
import { CRMCall } from '../../lib/store/crm/types';
import { calculateTimeRemaining, formatTimeRemaining, isDateBeforeNow } from '../../lib/util/DateTimeHelpers';
import { isCallStatusReady } from '../../lib/util/error-handling/StatusByCallHelpers';

import IconWarning from '../../assets/img/warning.png';

import styles from './CapitalBuySellButtonsConditions.module.scss';

type Props = ReduxProps & {
  noContent?: boolean;
  children: JSX.Element;
};

const CapitalBuySellButtonsConditions: FC<Props> = (props: Props): JSX.Element => {
  const { tradingPlan, isTradingPlanReady, children, noContent } = props;
  const { plans_accounts_activation: startDate } = tradingPlan;
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [isTournamentStarted, setIsTournamentStarted] = useState(false);
  const isTournamentEnded = isDateBeforeNow(tradingPlan.plans_accounts_deactivation);

  useEffect(() => {
    if (!isTradingPlanReady) {
      return;
    }
    calculateTimeRemaining(startDate, setIsTournamentStarted, setDays, setHours, setMinutes, setSeconds); // Initial calculation
    const intervalId = setInterval(() => {
      calculateTimeRemaining(startDate, setIsTournamentStarted, setDays, setHours, setMinutes, setSeconds);
    }, PredefinedMilisecondsTypeEnum.oneSecond);

    return () => clearInterval(intervalId); // eslint-disable-line consistent-return
  }, [startDate, isTradingPlanReady]);

  return (
    <>
      { (isTournamentStarted && !isTournamentEnded) ? (
        children
      ) : (
        <>
          {noContent ? <></> : (
            <div className={styles.notificationWrapper}>
              <div className={styles.info}>
                <div className={styles.iconWrapper}>
                  <img alt="" className={styles.icon} src={IconWarning} />
                </div>
                {isTournamentEnded ? (
                  <div className={styles.text}>
                    {lang.commonMyPositionTournamentEnded()}
                  </div>
                ) : (
                  <div className={styles.text}>
                    {lang.commonWelcomeToTournamentStartingAt()}
                    <span className={styles.time}>
                      {formatTimeRemaining(days, hours, minutes, seconds)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  tradingPlan: getDefaultSelectableTradingPLanFromState(state.crm),
  isTradingPlanReady: isCallStatusReady(CRMCall.searchTradingPlans, state.crm.statusByCall),
});

const connector = connect(mapStateToProps);
  type ReduxProps = ConnectedProps<typeof connector>;

export default connector(CapitalBuySellButtonsConditions);
